import axios from "axios";
import { FETCH_CUSTOMERS,SEND_EMAIL_CUSTOMERS,FETCH_VERIFY_EMAIL,DELETE_CUSTOMERS,FETCH_ZIPCODES,CREATE_ZIPCODES,UPDATE_ZIPCODES, DELETE_ZIPCODES,FETCH_ABANDONED_CARTS,SEND_MESSAGE_TO_ABANDON_CUSTOMERS,SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT,GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD,
  UPDATE_ABANDONED_CART_LEAD_INFO,FETCH_LOYAL_CUSTOMERS,FETCH_CUSTOM_TIME_ABANDONEDCART,interceptor 
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function fetchCustomers() {
  return {
    type: FETCH_CUSTOMERS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteCustomer(id) {
  return {
    type: DELETE_CUSTOMERS,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/single/delete/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id 
      }
    })
  };
}

export function sendEmailCustomer(data) {   
  return {
    type: SEND_EMAIL_CUSTOMERS,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/sendmedicalrecord`,data,{
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchVerifyEmail() { 
  return {
    type: FETCH_VERIFY_EMAIL,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/email`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchZipcodeLinks() {
    return {
      type: FETCH_ZIPCODES,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/zipcode-links`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function createZipCode(ZpCode) {
    return {
      type: CREATE_ZIPCODES,
      payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/zipcode-links`, ZpCode, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function updateZipCode(zipcode){
    return {
      type: UPDATE_ZIPCODES,
      payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/zipcode-links`, zipcode, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function deleteZipCode(id) {
    return {
      type: DELETE_ZIPCODES,
      payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/zipcode-links/${id}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function fetchAbandonedCarts() {
    return {
      type: FETCH_ABANDONED_CARTS,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/getAbandonedCart`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function sendMessageToAbandonCustomers(data) {
    return {
      type: SEND_MESSAGE_TO_ABANDON_CUSTOMERS,
      payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/send-messages-to-abandon-users`, data, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function abandonCustomersCount(data) {
    return {
      type: SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT,
      payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/send-messages-to-abandon-users`, data, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function getAbandonedCartCustomersViaMedicalRecord(id) {
    return {
      type: GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/abandonedCart/leads/${id}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function updateAbandonedCartLeadInfo(id,data) {
    return {
      type: UPDATE_ABANDONED_CART_LEAD_INFO,
      payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/abandonedCart/leads/${id}`,data, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };

  }

  export function fetchLoyalCustomers(data) {
    return {
      type: FETCH_LOYAL_CUSTOMERS,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/get-loyal-customers`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function fetchCustomTimeAbandonedCart(sDate,eDate) {
    return {
      type: FETCH_CUSTOM_TIME_ABANDONEDCART,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/customer/abandonedCart/timeDuration/${sDate}/${eDate}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

